// @flow
import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Base } from '@gandi/ui';

import CheckedList from './CheckedList';

type Props = {
  translator: TranslatorProps,
};

function AlreadyCustomerBox({ translator: { __ } }: Props) {
  return (
    <Base padding="small" backgroundColor="surface">
      <h3>{__('Already a customer?')}</h3>
      <Base tagName="p" marginBottom="small">
        {__(
          'Because we care about our customers, you get optimal pricing all year long.',
        )}
      </Base>
      <CheckedList
        items={[
          __('discount applied automatically,'),
          __('pricing rate decrease according to the volume,'),
          __('prices updated immediatly when registries lower their costs.'),
        ]}
      />
      <Base tagName="p" marginBottom="small">
        {__('No hidden costs.')}
      </Base>
    </Base>
  );
}

export default (React.memo<Props>(
  AlreadyCustomerBox,
  () => true,
): React.ComponentType<Props>);
